export enum Gender {
  MALE = 'MALE',

  FEMALE = 'FEMALE',

  OTHER = 'OTHER',
}
